import React, { useContext } from 'react';
import { Duration } from 'luxon';
import { ActivityRecordingContext } from './ActivityRecordingProvider';
import { styled } from '@mui/material/styles';

const ElapsedTimeViewContainer = styled('div')({
    color: 'white',
    fontSize: 12,
    '& .duration': {
        color: '#829AB1'
    }
});

const ElapsedTimeView = (props) => {
    const {
        videoPlaybackProgress,
        videoDuration
    } = useContext(ActivityRecordingContext);

    const elapsedTime = Duration.fromMillis(videoPlaybackProgress.playedSeconds * 1000);
    const formattedElapsedTime = elapsedTime.as('hours') > 1 ?
        elapsedTime.toFormat('hh:mm:ss') :
        elapsedTime.toFormat('mm:ss');

    const duration = Duration.fromMillis(videoDuration * 1000);
    const formattedDuration = duration.as('hours') > 1 ?
        duration.toFormat('hh:mm:ss') :
        duration.toFormat('mm:ss');

    return (
        <ElapsedTimeViewContainer {...props}>
            <span className="elapsedTime">{ formattedElapsedTime } </span>
            <span className="duration">/ { formattedDuration }</span>
        </ElapsedTimeViewContainer>
    );
};

export default ElapsedTimeView;
